
import { IconCondonation, IconPay, PersonChip } from '../../../../../../components/buttons/IconButtons';
import { EMPTY_VALUES, } from '../../../../../../Apis/functions';
import CustomCard from '../../../../../../components/CustomCard';
import FineStatusStepper from '../../SubComponents/StatusFines';

import React from 'react';
import { userType } from '../../../../../../enums/userTypeEnum';
import { useTranslation } from 'react-i18next';
import BannerComponentUser from './BannerComponentUser';
import PaymentItem from './PaymentItem';
import { TYPE_PAYMENT } from '../../Model/Model';
import AmountComponent from './AmountComponent';
import ComponentHeaderBack from './ComponentHeaderBack';
import {STATUS_MODEL} from '../../../../../../enums/statusEnum';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 * s
 */
const PaymentOptions = (
    {
        setPaymentOptions,
        trafficData,
        setShowPaymentModal
    }
) => {
    const { t } = useTranslation();

    return (
        <>
            <ComponentHeaderBack
                onHide={() => {
                    setPaymentOptions(false)
                }}
                title="payment_options"
                trafficData={trafficData}
                iconBack={true}
                showCustomChip={true}
                showVerticalSeparator={true}
            />
            <CustomCard classes={"w-100"} classCard={'card-border-8px'} classContent={'p-0 m-0'}>
                <div className="d-flex justify-content-between align-items-center m-3">
                    <BannerComponentUser
                        title={trafficData?.fullName || EMPTY_VALUES.DEFAULT}
                        nameChip={userType[trafficData?.userTypeId] ? t(userType[trafficData?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                        icon={<PersonChip width={32} height={32} />}
                    />
                    <FineStatusStepper
                        statusId={trafficData?.statusId}
                        statusScheduleId={trafficData?.statusScheduleId}
                        finePaymentDate={trafficData?.finePaymentDate}
                        createdAtFine={trafficData?.createdAt}
                        discountDate={trafficData?.discountDate}
                        paymentDate={trafficData?.paymentDate}
                        suspendedAccountDate={trafficData?.suspendedAccountDate}
                        discountApplied={trafficData?.discountApplied}
                        t={t}
                    />
                </div>
                <div className="border-bottom-shades-300" />
                <CustomCard classes={"w-100"} classCard={'border-0'}>
                    <div className="row d-flex justify-content-end">
                        <AmountComponent
                            folio={trafficData?.folio}
                            subtotal={trafficData?.fineAmount}
                            discount={trafficData?.discountAmount}
                            penalty={trafficData?.penaltyAmount}
                            paymentType={trafficData?.paymentType}
                            total={trafficData?.paidAmount}
                            isPaid={trafficData?.statusId === STATUS_MODEL.PAID }
                        />
                    </div>

                    <div className="d-flex flex-column gap-3 pt-2">
                        <PaymentItem
                            title={t("pay")}
                            subtitle={t("settle_the_fine_immediately")}
                            icon={<IconPay className="icon-color-general-950" />}
                            classNameContainer="w-56px-h-56px background-primary-100"
                            click={() => {
                                setShowPaymentModal(true, TYPE_PAYMENT.NORMAL)
                            }}
                        />
                        <PaymentItem
                            title={t("request_condonation")}
                            subtitle={t("appeal_or_dispute_the_fine")}
                            icon={<IconCondonation className="icon-color-general-950" />}
                            classNameContainer="w-56px-h-56px background-warning-100"
                            click={() => {
                                setShowPaymentModal(true, TYPE_PAYMENT.CONDONATION);
                            }}
                        />
                    </div>
                </CustomCard>
            </CustomCard>

        </>
    );

}

export default PaymentOptions
